import { render } from "./GamificationAccomplishmentsBadges.vue?vue&type=template&id=f6f7bbb2"
import script from "./GamificationAccomplishmentsBadges.vue?vue&type=script&lang=js"
export * from "./GamificationAccomplishmentsBadges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__